const LANGUAGE_FR = 'fr'
const LANGUAGE_IT = 'it'
const LANGUAGE_ES = 'es'
const LANGUAGE_EN = 'en'
const LANGUAGE_DE = 'de'

export const types = {
  FR: LANGUAGE_FR,
  IT: LANGUAGE_IT,
  ES: LANGUAGE_ES,
  EN: LANGUAGE_EN,
  DE: LANGUAGE_DE
}
